import React from "react";
import "./cardHeader.scss";

export const CardHeader = ({ title }) => {
  return <p className={"cardHeader__title"}>{title}</p>;
};

export default CardHeader;
